<div class="dialog">
    <div>
        <img src="assets/svg/Sucess.svg" alt="">
        <h6 class="text-center mt-2 mb-2">Confirm To Submit the Quote</h6>

    </div>
    <div class="content ">
        <p class="text-center mt-4">By clicking on "Confirm" the quote will be submitted.</p>
    </div>
    <div class="footer row mt-5">
        <button (click)="close()" class="mr-2 white">Cancel</button>
        <button (click)="submit()" class="ml-2 orange">Confirm</button>
    </div>

</div>